import { useEffect, useMemo, useState } from "react";
import { STORAGE } from "../constants";
import { LocalStorageService } from "../services/LocalStorageService";

export const useCurrentAccount = () => {

    const [account] = useState(LocalStorageService.get(STORAGE.ACCOUNT_SELECTED))


    return {
        account
    }
}